
<app-card-actions heading="Priority Cards" (close)="close()"></app-card-actions>
<div class="notifications">


    <app-card-due-dates [fixedHeight]="false" (clicked)="navigateToCard($event)" [fullWidth]="true" [cards]="userCards" ></app-card-due-dates>

</div>